import React, { useEffect, useState } from "react";
import { Typography, Spin } from 'antd';
import ReportsForBanker from "./ReportsForBanker";
import SidebarLayout from "./SidebarLayout";
const { Title } = Typography;


const BankerReports = () => {

    const [loading, setLoading] = useState(false);
  

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                <div>
                    <ReportsForBanker ApplicantId={1}/>
                </div>

            </SidebarLayout >
        </Spin >
    );
};

export default BankerReports;